import { create } from "zustand";
import { persist } from "zustand/middleware";

interface WorkspaceState {
  activeWorkspaceId: string | null;
  setActiveWorkspaceId: (workspaceId: string | null) => void;
  activeProjectId: string;
  setActiveProjectId: (projectId: string) => void;
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      activeWorkspaceId: null,
      setActiveWorkspaceId: (workspaceId) =>
        set({ activeWorkspaceId: workspaceId }),
      activeProjectId: "",
      setActiveProjectId: (projectId) => set({ activeProjectId: projectId }),
    }),
    {
      name: "workspace-storage",
    },
  ),
);
